export const SET_TABLE_FILTER_CACHE = 'SET_TABLE_FILTER_CACHE';
export const CLEAR_TABLE_FILTER_CACHE = 'CLEAR_TABLE_FILTER_CACHE';
export const CLEAR_ALL_TABLE_FILTER_CACHE = 'CLEAR_ALL_TABLE_FILTER_CACHE';